export const skills = [
  {
    id: 1,
    name: 'Languages',
    items: ['JavaScript', 'Ruby', 'Python', 'SASS', 'HTML5', 'Java']
  },
  {
    id: 2,
    name: 'Frameworks & Libraries',
    items: ['React', 'Node.js', 'Express', 'Rails', 'Material UI', 'Axios', 'Socket IO', 'WebSockets', 'jQuery', 'EJS', 'Bootstrap']
  },
  {
    id: 3,
    name: 'Testing Libraries',
    items: ['Mocha', 'Chai', 'Jest', 'Storybook', 'RSpec', 'Capybara', 'Poltergeist']
  },
  {
    id: 4,
    name: 'Systems, CMS, & Databases',
    items: ['SQL', 'PostgreSQL', 'Git', 'WordPress']
  },
  {
    id: 5,
    name: 'Software',
    items: ['Adobe Photoshop', 'Adobe XD', 'Adobe Lightroom', 'Final Cut Pro X']
  }
]